import type { ColumnDef } from '@tanstack/react-table';

import { DataTableColumnHeader } from '@/components/dataTable/ColumnHeader';
import { useDynamicLocale } from '@/hoslog-intl';
import { EyeIcon } from '@/icons';
import { formatDate } from '@/lib/dateFormatter';
import { formatAmount } from '@/lib/format';
import { AffiliateData } from '@/services/payment/payment.types';
import { Link } from '@tanstack/react-router';

export function getColumns(t: ReturnType<typeof useDynamicLocale>['t']): ColumnDef<AffiliateData>[] {
  return [
    {
      accessorKey: 'sn',
      header: ({ column }) => <DataTableColumnHeader column={column} title="S.N" />,
      cell: ({ row }) => <div className="font-medium truncate max-w-[10rem]">{row.getValue('sn')}</div>,
      enableSorting: false,
    },
    {
      accessorKey: 'monthandyear',
      header: ({ column }) => (
        <DataTableColumnHeader column={column} title={t('common.page.tableColumn.monthAndYear')} />
      ),
      cell: ({ row }) => (
        <div className="font-medium truncate max-w-[20rem]">
          {formatDate(row.getValue<string>('monthandyear'), 'MMM YYYY')}
        </div>
      ),
      meta: {
        label: 'Month and Year',
      },
      enableHiding: false,
    },
    {
      accessorKey: 'withdrawDay',
      header: ({ column }) => (
        <DataTableColumnHeader column={column} title={t('common.page.tableColumn.withdrawDay')} />
      ),
      cell: ({ row }) => <div>{row.getValue('withdrawDay')}</div>,
      meta: {
        label: 'Withdraw Day',
      },
      enableHiding: false,
    },
    {
      accessorKey: 'totalRequestedAmount',
      header: ({ column }) => (
        <DataTableColumnHeader column={column} title={t('common.page.tableColumn.requestedAmount')} />
      ),
      cell: ({ row }) => <div>{formatAmount(row.original.totalRequestedAmount)}</div>,
      meta: {
        label: 'Total Requested Amount',
      },
      enableHiding: false,
    },
    {
      id: 'actions',
      header: ({ column }) => <DataTableColumnHeader column={column} title={t('common.page.tableColumn.action')} />,
      cell: ({ row }) => (
        <Link
          to="/payment-management/affiliate-log/$monthly-report"
          params={{ 'monthly-report': row.original.monthandyear }}
        >
          <EyeIcon className="stroke-warning size-4" />
        </Link>
      ),
      size: 40,
    },
  ];
}
